module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/anti-harlem-shake"},"excerpt":"Devenir fan :  http://www.facebook.com/PofMagicfingersFans \nTwitter :  http://twitter.com/pofmagicfingers","timeToRead":1,"frontmatter":{"title":"ANTI Harlem Shake","tags":["PofMagicfingers","youtube","video","Pof","Magicfingers","Pof Magicfingers","Harlem Shake","Original","Remix","Anti","Anti Harlem","Shake","Anti Harlem Shake","Harlem","Anti HS","Inverse"],"cover":null,"date":"2013-03-07T07:00:43.000Z"}}}]}},"pathContext":{"tag":"Remix"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-remix.json
// module id = 937
// module chunks = 203542839793359